import type { Icon } from "./types";

export type Props = {
	icon: Icon;
	params?: Record<string, string>;
	className?: string;
};

export default function SVGIcon({ params, icon, className }: Props) {
	const { H, W, body } = icon;
	const { FILL = "transparent" } = params ?? {};
	return (
		<svg
			width={W}
			height={H}
			viewBox={`0 0 ${W} ${H}`}
			fill={FILL}
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			// biome-ignore lint/security/noDangerouslySetInnerHtml: no user generated content
			dangerouslySetInnerHTML={{ __html: body(params) }}
		/>
	);
}
